<script setup lang="ts">
// Mid-page call to action right after the editor demo, where intent peaks:
// the same claim widget as the hero, reported as location "inline".
defineProps<{
  title: string
  description: string
}>()
</script>

<template>
  <UContainer class="pb-4">
    <div class="flex flex-col items-center gap-6 rounded-2xl border border-default bg-elevated/40 px-6 py-8 text-center shadow-(--surface-shadow) md:flex-row md:justify-between md:gap-10 md:px-10 md:text-left">
      <div class="max-w-sm">
        <p class="text-xl font-semibold text-highlighted">
          {{ title }}
        </p>
        <p class="mt-1.5 text-sm text-muted">
          {{ description }}
        </p>
      </div>
      <HeroClaimUsername
        variant="compact"
        location="inline"
        class="md:max-w-md"
      />
    </div>
  </UContainer>
</template>
